import React from "react";
import * as styles from "./PhonePreview.styles";

export interface PhonePreviewProps {
  os: "ios" | "android";
  message: string;
  senderNumber?: string;
}

function SpeechBubbleIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M4 5h16a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9l-4 4v-4H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}

function StatusIcons() {
  return (
    <span style={styles.statusIcons}>
      {/* signal */}
      <svg width="16" height="10" viewBox="0 0 16 10" aria-hidden="true">
        <rect x="0" y="6" width="3" height="4" fill="currentColor" />
        <rect x="4.5" y="4" width="3" height="6" fill="currentColor" />
        <rect x="9" y="2" width="3" height="8" fill="currentColor" />
        <rect x="13" y="0" width="3" height="10" fill="currentColor" />
      </svg>
      {/* wifi */}
      <svg width="14" height="10" viewBox="0 0 14 10" aria-hidden="true">
        <path
          d="M1 3.5C4.5 0.5 9.5 0.5 13 3.5M3 6C5.2 4.2 8.8 4.2 11 6M5.3 8.3C6.3 7.4 7.7 7.4 8.7 8.3"
          stroke="currentColor"
          strokeWidth="1.4"
          fill="none"
        />
      </svg>
      {/* battery */}
      <svg width="20" height="10" viewBox="0 0 20 10" aria-hidden="true">
        <rect
          x="0.5"
          y="0.5"
          width="16"
          height="9"
          rx="2"
          stroke="currentColor"
          fill="none"
        />
        <rect x="17.5" y="3" width="1.5" height="4" fill="currentColor" />
        <rect x="2" y="2" width="12" height="6" fill="currentColor" />
      </svg>
    </span>
  );
}

/**
 * Presentational phone mockup. The iOS/Android toggle lives in the parent,
 * which flips `os`.
 */
function PhonePreview(props: PhonePreviewProps) {
  const { os, message, senderNumber } = props;
  const isIos = os === "ios";
  const trimmed = message.trim();

  return (
    <div
      style={isIos ? styles.bezel : styles.bezelAndroid}
      data-testid="phone-preview"
      data-os={os}
    >
      <div style={isIos ? styles.screen : styles.screenAndroid}>
        <div style={styles.statusBar}>
          <span>9:41</span>
          <StatusIcons />
        </div>
        <div style={styles.contactHeader}>
          <div style={styles.avatar}>{isIos ? "📱" : "🤖"}</div>
          <div style={styles.contactNumber}>
            {senderNumber || "Your sender number"}
          </div>
        </div>
        {trimmed ? (
          <div style={styles.body}>
            <div style={isIos ? styles.bubble : styles.bubbleAndroid}>
              {message}
            </div>
            <div style={styles.deliveredCaption}>
              Delivered · {senderNumber || "your number"}
            </div>
          </div>
        ) : (
          <div style={styles.emptyState}>
            <SpeechBubbleIcon />
            <div style={styles.emptyTitle}>Nothing to see yet</div>
            <div style={styles.emptyMessage}>
              Start typing and your message shows up here, exactly as it lands.
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PhonePreview;
